import { Button, CircularProgress } from "@mui/material";
import plus from "../Assets/tabler_plus.svg";

const ButtonComponent = ({ loader, name, onClick, dashboard, styles, loaderColor }) => {
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        className="login-submit"
        style={{
          fontFamily:"Urbanist",

          padding: "10px 40px",
          margin: "7px auto",
          backgroundColor: "#12188A",
          borderRadius: "52px",
          textTransform: "capitalize",
          color: "white",
          "&:hover": {
            border: "none",
            backgroundColor: "#000",
          },
          width: dashboard ? "15%" : "100%",
          // height: '25px'
          ...styles,
        }}
        disabled={loader}
        onClick={onClick}
      >
        {loader ? <CircularProgress size={23} color="primary" sx={{ color: loaderColor || styles?.color || '#fff' }} /> : name}
      </Button>
    </>
  );
};
export default ButtonComponent;
